import zhCn from './lang/zh-cn';
import en from "./lang/en";

const lang = {
  'zh-cn': zhCn,
  'en': en
};

export default lang;